import {useTranslation} from 'react-i18next'
import {graphql, useStaticQuery} from 'gatsby'

export type BannerType = {
    content: string
    path: string
}

const useLayoutBanner = (): BannerType | null => {
    try {
        const {i18n} = useTranslation()

        const data = useStaticQuery(
            graphql`
                query {
                    allStrapiBanner {
                        edges {
                            node {
                                locale
                                content
                                start_date
                                end_date
                                redirect_url
                            }
                        }
                    }
                }
            `
        )

        const bannerForCurrentLanguage = data.allStrapiBanner.edges.find(
            ({node}) => node.locale === i18n.language
        )?.node

        if (bannerForCurrentLanguage?.content?.length > 0) {
            const now = new Date()
            const startDate = new Date(bannerForCurrentLanguage.start_date)
            const endDate = new Date(bannerForCurrentLanguage.end_date)

            const shouldShowBanner = startDate <= now && now <= endDate

            if (shouldShowBanner) {
                return {
                    content: bannerForCurrentLanguage.content,
                    path: bannerForCurrentLanguage.redirect_url,
                }
            }
        }
        return null
    } catch (e) {
        return null
    }
}

export default useLayoutBanner
